// extracted by mini-css-extract-plugin
export var box = "_3d-0";
export var check = "_3d-1";
export var checkboxButton = "_3d-6";
export var checkboxGroup = "_3d-5";
export var disabled = "_3d-7";
export var ghost = "_3d-9";
export var input = "_3d-2";
export var label = "_3d-4";
export var normal = "_3d-8";
export var uncheck = "_3d-3";